// extracted by mini-css-extract-plugin
export default {"ButtonBase":"ButtonBase-module--ButtonBase--JfmuO","disabled":"ButtonBase-module--disabled--i8d4N","block":"ButtonBase-module--block--RI5lc"};